<template>
    <div class="upgrade">
        <div class="upgrade-body">
            <div class="upgrade-body-top">
                <img src="../../assets/upgrades/header.png" alt="页面顶部图片">
            </div>
            <div class="upgrade-body-vip">
                <img src="../../assets/upgrades/vip.png" alt="vip图片">
                <van-button class="upgrade-body-vip-btn" block @click="getCooperationProgram">立即升级</van-button>
            </div>
            <div class="upgrade-body-svip">
                <img src="../../assets/upgrades/svip.png" alt="svip图片">
            </div>
            <div class="upgrade-body-consult">
                <img src="../../assets/upgrades/consult.png" alt="咨询图片">
                <van-button class="upgrade-body-consult-btn" block @click="getServiceUrl">咨询优惠</van-button>
            </div>
            <div class="upgrade-body-equity">
                <img src="../../assets/upgrades/equity.png" alt="权益图片">
            </div>
            <div class="upgrade-body-btns">
                <van-button class="upgrade-body-btns-left" block @click="getServiceUrl">咨询客服</van-button>
                <van-button class="upgrade-body-btns-right" block @click="getCooperationProgram">
                    <img src="../../assets/upgrades/heart.png" alt="">
                    <span>立即升级</span>
                </van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import { customerService } from "../../utils/getCustomerService"
    import { jumpProgram } from '../../utils/jumpProgram'
    import { ref, getCurrentInstance } from 'vue'
    import { getAppToken } from "../../utils/getAppToken";
    export default {
        // 续费升级
        name: 'RenewalUpgrade',
        setup() {
            const { proxy } = getCurrentInstance();
            const token = ref('')
            getAppToken('token').then(() => {
                token.value = localStorage.getItem('appToken')
            });
            const getServiceUrl = () => {
                proxy.$http.post('/base/kefu').then(({ data: res }) => {
                    if(res.success) {
                        customerService(res.data)
                    } else {
                        this.$toast.fail(res.errorMessage);
                    }
                })
            }
            const getCooperationProgram = () => {
                const id = 11044
                const sid = 2749
                const cid = ''
                proxy.$http.post(
                    '/h5/store_mini',
                    { id, sid },
                    { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
                ).then(({ data: res }) => {
                    if(res.success) {
                        let obj = res.data
                        obj.sid = sid
                        obj.cid = cid
                        jumpProgram(obj)
                    } else {
                        this.$toast.fail(res.errorMessage);
                    }
                })
            }
            return {
                getServiceUrl,
                getCooperationProgram
            }
        }
    }
</script>

<style lang="scss" src="./index.scss"></style>
